// Rolling digits (Theme settings > Motion > Roll changing numbers): a number that
// changes rolls digit by digit, like a counter. Used by the product price on
// variant change (product.js) and the header cart count (global.js) on elements
// marked data-rolling-digits.
// Screen readers get the final text once, from a visually hidden copy; the
// rolling copy is aria-hidden and drawn with CSS content, so the element's
// textContent stays the plain value. Reduced motion: the text just changes.
(function () {
  'use strict';

  if (window.AxiomRollingDigits) return;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function isDigit(character) {
    return character >= '0' && character <= '9';
  }

  // The value shown now, without a visually hidden label in front of it.
  function currentText(element) {
    var rolled = element.querySelector(':scope > .rolling-digits');
    if (rolled && rolled.previousElementSibling) return rolled.previousElementSibling.textContent;
    return Array.prototype.map.call(element.childNodes, function (node) {
      if (node.nodeType === 1 && node.classList.contains('visually-hidden')) return '';
      return node.textContent;
    }).join('').trim();
  }

  function set(element, value) {
    var text = String(value);
    var previous = currentText(element);
    if (reducedMotion.matches || previous === text || !/\d/.test(text)) {
      element.textContent = text;
      return;
    }

    var finalText = document.createElement('span');
    finalText.className = 'visually-hidden';
    finalText.textContent = text;
    var rolling = document.createElement('span');
    rolling.className = 'rolling-digits';
    rolling.setAttribute('aria-hidden', 'true');

    // Digits are matched from the right, so "$9.99" to "$12.49" rolls the cents
    // and the units in place and the new leading digit rolls up from 0.
    var order = 0;
    for (var i = 0; i < text.length; i++) {
      var character = text.charAt(i);
      var oldCharacter = previous.charAt(previous.length - (text.length - i));
      var span = document.createElement('span');
      if (isDigit(character)) {
        var from = isDigit(oldCharacter) ? oldCharacter : '0';
        span.className = 'rolling-digits__digit';
        span.dataset.digit = character;
        span.style.setProperty('--rd-to', character);
        if (oldCharacter !== character) {
          span.classList.add('is-rolling');
          span.style.setProperty('--rd-from', from);
          span.style.setProperty('--rd-order', order);
          order += 1;
        }
      } else {
        span.className = 'rolling-digits__char';
        span.dataset.char = character;
      }
      rolling.appendChild(span);
    }

    element.textContent = '';
    element.appendChild(finalText);
    element.appendChild(rolling);
  }

  window.AxiomRollingDigits = { set: set };
})();
